<cass-core-toolbar></cass-core-toolbar>
<div class="page-container">
	<h1>{{ "USERS.ACCOUNT_CREATED.PAGE_TITLE" | translate }}</h1>
	<mat-card>
		<mat-card-content>
			<img src="branding/home-account.png" />
				<div class="confirmaton-message">
					{{ "USERS.ACCOUNT_CREATED.CONFIRMATION_MESSAGE" | translate }}
				</div>
				<div class="action-bar">
					<button mat-raised-button color="accent" routerLink="/login">{{ "LOGIN.LOGIN_BUTTON_LABEL" | translate }}</button>
				</div>
		</mat-card-content>
	</mat-card>
</div>

